import React from 'react';
import {
  Copy,
  Flex,
  Loader,
  Squish,
  Stack,
} from '@grubhubprod/gh-cookbook-react';

interface InsightsDashboardLoaderProps {
  variant?: 'default' | 'compact';
}

const HEIGHT_BY_VARIANT: Record<
  NonNullable<InsightsDashboardLoaderProps['variant']>,
  string
> = {
  default: '328px',
  compact: '252px',
};

export function InsightsDashboardLoader({
  variant = 'default',
}: InsightsDashboardLoaderProps): JSX.Element {
  return (
    <Squish
      bg="globals.white"
      borderRadius="medium"
      height={HEIGHT_BY_VARIANT[variant]}
    >
      <Flex
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100%"
      >
        <Stack y="x-sm">
          <Loader size="md" />
        </Stack>
        <Copy variant="body">Loading...</Copy>
      </Flex>
    </Squish>
  );
}
